import { CONTENT_ROUTES } from './shared/routes/content-layout.routes';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';
import { FULL_ROUTES } from './shared/routes/full-layout.routes';
import { FullLayoutComponent } from './layouts/full/full-layout.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const appRoutes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
    },

    // There are two groups of layouts:
    // "Full" pages are the main "app" modules, like dashboard, user management, etc.
    { path: '', component: FullLayoutComponent, data: { title: 'full Views' }, children: FULL_ROUTES },
    // "Content" pages are the generic pages in the app such as the 404, Login, Under Construction, etc...
    { path: '', component: ContentLayoutComponent, data: { title: 'content Views' }, children: CONTENT_ROUTES },
    // App will redirect to the 404 page if the user tries to navigate to a route that does not exist
    {
        path: '**',
        redirectTo: 'pages/error'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes, {
        scrollPositionRestoration: 'enabled'
    })], exports: [RouterModule]
})

export class AppRoutingModule {
}
